require('./bootstrap');

require('alpinejs');

require('bootstrap');